import { Navigate } from "react-router-dom";
import userService from "../helpers/user.service";

export default function RoleGuard({ allowedRoles, children }) {
  const user = userService.Get_User();
  if (!user || !allowedRoles.includes(user.roleID)) {
    return <Navigate to="/page-not-found" replace />;
  }

  return children;
}